import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18n';
import { Icon } from 'Components/Base';

const i18nOpts = { scope: 'care_plans.checkin_section.checkin_order' };

const CheckIn = ({ name, completed, formattedDueAt }) => (
  <li className="order">
    <div className="order__section text-truncate">
      <div>
        <strong>{name}</strong>
      </div>
      <span>{formattedDueAt && t('due_at_statement', { ...i18nOpts, dueDate: formattedDueAt })}</span>
    </div>
    <div className="order__section">
      {completed ? (
        <span className="order--complete">
          <Icon name="check_alt3" className="order__section--check-icon" />
          {t('completed', i18nOpts)}
        </span>
      ) : (
        <span className="order--due">{t('not_completed', i18nOpts)}</span>
      )}
    </div>
  </li>
);

CheckIn.propTypes = {
  completed: PropTypes.bool,
  formattedDueAt: PropTypes.string,
  name: PropTypes.string.isRequired,
};

CheckIn.defaultProps = {
  completed: false,
  formattedDueAt: '',
};

export default CheckIn;
